<template>
    <page>
        <module title="中奖详情">
            <div v-if="lotteryWinRecordInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="中奖会员手机号">
                        {{lotteryWinRecordInfo.user_manage_mobilephone}}
                    </c-detail-item>
                    <c-detail-item label="中奖会员昵称">
					<span v-if="lotteryWinRecordInfo.nick_name && lotteryWinRecordInfo.nick_name!=''">
						{{lotteryWinRecordInfo.nick_name}}
					</span>
                        <span v-else>--</span>
                    </c-detail-item>
                    <c-detail-item label="中奖会员头像">
                        <c-image :src="lotteryWinRecordInfo.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                    </c-detail-item>
                    <c-detail-item label="中奖时间">{{lotteryWinRecordInfo.create_date}}</c-detail-item>
                    <c-detail-item label="奖项名称">{{lotteryWinRecordInfo.lottery_award_name}}</c-detail-item>
                    <c-detail-item label="奖品类型">
                        <template v-slot="{data}">
                            <span v-if="lotteryWinRecordInfo.award_type==1">商品</span>
                            <span v-if="lotteryWinRecordInfo.award_type==2" style="color:darkgreen">积分</span>
                            <span v-if="lotteryWinRecordInfo.award_type==3" style="color:blue">优惠券</span>
                        </template>
                    </c-detail-item>
                    <c-detail-item label="奖品信息">
                        <template v-slot="{data}">
                            <product-info v-if="lotteryWinRecordInfo.award_type==1" :image="lotteryWinRecordInfo.product_img_url" :name="lotteryWinRecordInfo.product_name" image-size="60"></product-info>
                            <span v-else>
                                {{lotteryWinRecordInfo.product_name}}
                            </span>
                        </template>
                    </c-detail-item>
                    <c-detail-item label="奖品发放状态">
                        <template v-slot="{data}">
                            <span v-if="lotteryWinRecordInfo.state==1" style="color:darkgreen">{{stateName[lotteryWinRecordInfo.state]}}</span>
                            <span v-if="lotteryWinRecordInfo.state==0" style="color:red">{{stateName[lotteryWinRecordInfo.state]}}</span>
                        </template>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'lottery_win_record_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                lotteryWinRecordInfo: '',
                productList: [],
                couponList: [],
                stateName: {
                    0: '待发放',
                    1: '已发放'
                }
            }
        },

        computed: {
            ...mapState(['dict'])

        },

        watch: {
            id() {
                this.getEvaluateDetail();
            }
        },

        mounted() {
            this.getEvaluateDetail();
        },

        methods: {
            getEvaluateDetail() {
                this.request({
                    url: '/lottery_win_record/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.lotteryWinRecordInfo = data;
                    }
                });
            }
        }
    }
</script>